import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';
// 라이더 관리 > 라이더 수수료 그룹 설정(delivery-fee-group-setting) 페이지
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
